export default function ExecutiveSection({
  title,
  subtitle,
  children,
  actions,
  className = "",
}) {

  return (
    <section
      className={`bg-white border border-slate-200 rounded-2xl p-6 shadow-sm ${className}`}
    >

      {(title || subtitle || actions) && (
        <div className="flex items-start justify-between gap-6 mb-6">

          <div>
            {title && (
              <h2 className="text-xl font-semibold text-slate-900">
                {title}
              </h2>
            )}

            {subtitle && (
              <p className="mt-1 text-sm text-slate-500">
                {subtitle}
              </p>
            )}
          </div>

          {actions && (
            <div>
              {actions}
            </div>
          )}
        </div>
      )}

      {children}

    </section>
  );
}